export const APP_PROGRESSBAR = {
  "Progressbar.Bg.Color": {
    defaultValue: "transparent"
  },
  "Progressbar.Bar.Bg.Color": {
    ref: "Color.Gray.300"
  },
  "Progressbar.Bar.Fill.Bg.Color": {
    ref: "Color.Secondary.One.500"
  },
  "Progressbar.Bar.Height": {
    defaultValue: "10px"
  },
  "Progressbar.Bar.Border.Top.Left.Radius": {
    defaultValue: "50%"
  },
  "Progressbar.Bar.Border.Top.Right.Radius": {
    defaultValue: "50%"
  },
  "Progressbar.Bar.Border.Bottom.Left.Radius": {
    defaultValue: "50%"
  },
  "Progressbar.Bar.Border.Bottom.Right.Radius": {
    defaultValue: "50%"
  },
  "Progressbar.Label.Color": {
    ref: "Input.Color"
  },
  "Progressbar.Label.Font.Size": {
    ref: "Input.Font.Size"
  },
  "Progressbar.Label.Font.Weight": {
    ref: "Input.Font.Weight"
  },
  "Progressbar.Value.Color": {
    ref: "Input.Color"
  },
  "Progressbar.Value.Font.Size": {
    ref: "Input.Font.Size"
  },
  "Progressbar.Value.Font.Weight": {
    ref: "Input.Font.Weight"
  },
  "Progressbar.Border.Top.Left.Radius": {
    defaultValue: "0"
  },
  "Progressbar.Border.Top.Right.Radius": {
    defaultValue: "0"
  },
  "Progressbar.Border.Bottom.Left.Radius": {
    defaultValue: "0"
  },
  "Progressbar.Border.Bottom.Right.Radius": {
    defaultValue: "0"
  },
  "Progressbar.Padding.Top": {
    defaultValue: "0"
  },
  "Progressbar.Padding.Right": {
    defaultValue: "0"
  },
  "Progressbar.Padding.Bottom": {
    defaultValue: "0"
  },
  "Progressbar.Padding.Left": {
    defaultValue: "0"
  },
  "Progressbar.Shadow": {
    defaultValue: "none"
  },
  "Progressbar.Min.Width": {
    defaultValue: "0"
  },
  "Progressbar.Max.Width": {
    defaultValue: "unset"
  },
  "Progressbar.Width": {
    defaultValue: "100%"
  },
  "Progressbar.Height": {
    defaultValue: "auto"
  },
  "Progressbar.Min.Height": {
    defaultValue: "unset"
  },
  "Progressbar.Max.Height": {
    defaultValue: "unset"
  },
  "Progressbar.Margin.Top": {
    defaultValue: "0"
  },
  "Progressbar.Margin.Right": {
    defaultValue: "0"
  },
  "Progressbar.Margin.Left": {
    defaultValue: "0"
  },
  "Progressbar.Margin.Bottom": {
    defaultValue: "0"
  },

  // old page meta variables reference
  "Progressbar.Color": {
    ref: "Progressbar.Bar.Fill.Bg.Color"
  },
  "Progressbar.Bar.Color": {
    ref: "Progressbar.Bar.Bg.Color"
  }
};
